'use strict';

const catNavGuidedBuying = '.cat-nav-guided-buying';

/**
 * Mobile stacked layout if tiles odd number change layout of first div.
 * @param {*} element - category nav guided buying component
 */
function mobileStackedLayout(element) {
    var stackTileContainer = element.find('.row');
    var StackTileCount = stackTileContainer.children().length;

    if (StackTileCount % 2 !== 0) {
        var firstStackTile = stackTileContainer.children(':first');
        $(firstStackTile).addClass('stacked-layout');
    }
}

module.exports = {
    initCatNavGuidedBuying: function () {
        $(catNavGuidedBuying).each(function () {
            var mobileStack = $(this).find('.only-mobile.pb-2');
            mobileStackedLayout(mobileStack);
        });
    }
};
